import React from 'react'
import { useState } from 'react'
import AddDWG from '../../../../../components/Operations/Engineering/DWG/AddDWG/AddDWG'
import { get, isEmpty, pick } from 'lodash'

import useFetchObject from '../../../../../elements/Hooks/useFetchObject'
import { EnquiriesApi } from '../../../../../api/Sales/Enquiries'
import useTitle from '../../../../../elements/Hooks/useTitle'
import useFetchList from '../../../../../elements/Hooks/useFetchList'
import useModalShow from '../../../../../elements/Hooks/useModalShow'
import Members from '../../../../../api/Members'
import useSubmit from '../../../../../elements/Hooks/useSubmit'
import { DWGApi } from '../../../../../api/Operations/Engineering/DWG'
import { withRouter } from 'react-router-dom'
import { message } from 'antd'
import { MODAL_TYPE_NEW } from '../../../../../elements/Hooks/useModalData'
import DocumentsApi from '../../../../../api/Documents'
import Templates from '../../../../../api/Templates'
import Email from '../../../../../api/Email'
import qs from 'query-string'

const formRef = React.createRef()
const docsApi = new DocumentsApi()
const templateApi = new Templates()
const emailApi = new Email()

AddDWGCont.propTypes = {}

function AddDWGCont(props) {
  const key = get(props.match, 'params.key')
  const values = qs.parse(props.location.search)
  const enquiryID = values.enquiryID
  const type = key ? 'edit' : 'new'

  const { fetch, fetching, object: dwg, setObject: setDWG } = useFetchObject(
    () => DWGApi.read(key),
    false,
    [key],
    isEmpty(key)
  )

  useTitle(dwg.code === undefined ? `Create New DWG` : `${dwg.code} DWG`)
  const [isMemberOrganization, setIsMemberOrganization] = useState(true)
  const [ContactPersonLoading, setContactPersonLoading] = useState(false)
  const [contactPerson, setContactPerson] = useState([])
  const { list: enquirerList, fetching: fetchingEnquirer, fetch: fetchEnquirer } = useFetchList(
    EnquiriesApi.enquirerList
  )
  const { visible: visiblePhonebook, onShow: onShowPhoneBook, onCancel: onCancelPhoneBook } = useModalShow(
    undefined,
    fetchEnquirer
  )

  const onChangeEnquirer = async (id) => {
    console.log('onChangeEnquirer')
    if (id) {
      setContactPersonLoading(true)
      const key = id.replace('members/', '')
      const membersApi = new Members()
      const memberResponse = await membersApi.get(key)
      let memberData = await memberResponse.json()
      setIsMemberOrganization(memberData.kind !== 'individual')
      const response = await membersApi.representatives.list(key)
      let data = await response.json()
      setContactPerson(data)
      setContactPersonLoading(false)
      return id
    }
  }

  const [updating, updateFunc] = useSubmit(DWGApi.update)

  function checkForm() {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  const [submitting, submitFunc] = useSubmit(DWGApi.create)

  async function submit() {
    const values = await checkForm()
    const submitted = await submitFunc(values)
    if (submitted)
      props.history.push({
        pathname: `/operations/engineering/dwg/${submitted._key}/update`,
      })
  }

  async function update() {
    const values = await checkForm()
    const dwgDB = await updateFunc({
      ...pick(dwg, ['_key', '_id', '_rev']),
      ...values,
    })
    if (dwgDB) setDWG(dwgDB)
  }

  const [removing, removeFunc] = useSubmit(DWGApi.remove)

  async function remove() {
    const removed = await removeFunc({
      ...pick(dwg, ['_key', '_rev', '_id']),
    })
    if (removed)
      props.history.replace({
        pathname: `/operations/engineering/dwg/`,
      })
  }

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('dwg', dwg.status),
    [dwg.status, isEmpty(dwg.status)]
  )
  const isNew = type === MODAL_TYPE_NEW
  const isUpdatable = actions.find((a) => a.key === 'update') || isNew
  const [submittingOperation, submitOperation] = useSubmit(DWGApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    const DWGDB = await submitOperation({
      status: operation,
      ...pick(dwg, ['_key', '_rev', '_id']),
    })
    if (DWGDB) {
      setDWG(DWGDB)
    }
    hide()
  }

  const [submittingTemplate, submitTemplate] = useSubmit(templateApi.read, true)
  const [submittingDWGTemplate, submitDWGTemplate] = useSubmit(emailApi.dwgTemplate, true)
  const [submittingDWGFiles, submitDWGFiles] = useSubmit(DWGApi.files, true)

  const [emailTemplate, setEmailTemplate] = useState('')
  const [emailDetails, setEmailDetails] = useState('')
  const [emailFiles, setEmailFiles] = useState([])
  const [emailLines, setEmailLines] = useState([])

  const { visible: visibleEmail, onShow: onShowEmail, onCancel: onCancelEmail } = useModalShow(async () => {
    let hide = message.loading('Fetching Email Template ...', 0)

    const company = get(dwg, 'company._id', '').replace('members/', '')
    const dwgTemplate = await submitTemplate(company, 'dwg')
    const emailDetails = get(dwgTemplate, 'email') || {}
    const data = await submitDWGTemplate({
      receiver: get(dwg, 'vendorRep.fn'),
      ...emailDetails,
    })

    const filesList = await submitDWGFiles([dwg._id])
    setEmailFiles(filesList)
    const filesMapped = filesList.map((f) => f.uuid)
    setEmailTemplate(data.html)
    setEmailDetails({
      to: get(dwg, 'vendorRep.email.label'),
      bcc: get(emailDetails, 'bcc'),
      from: get(emailDetails, 'from'),
      subject: get(emailDetails, 'subject'),
      attachments: filesMapped,
    })
    setEmailLines([dwg])
    hide()
  })
  const isConfirmed = ['Confirmed'].includes(dwg.status)
  const isIssued = get(dwg, 'issuance.issued') === true

  React.useEffect(() => {
    if (get(dwg, 'vendor._id')) onChangeEnquirer(dwg.vendor._id)
  }, [dwg._key])
  const [modalID, setModalID] = React.useState(1)
  React.useEffect(() => {
    setModalID((old) => old + 1)
  }, [enquirerList.length])
  return (
    <AddDWG
      {...{
        type,
        enquiryID,
        fetching,
        submitting,
        updating,
        fetch,
        dwg,
        submit,
        removing,
        remove,
        update,
        formRef,
        visiblePhonebook,
        onShowPhoneBook,
        onCancelPhoneBook,
        onChangeEnquirer,
        contactPerson,
        setContactPerson,
        enquirerList,
        fetchingEnquirer,
        fetchEnquirer,
        ContactPersonLoading,
        setContactPersonLoading,
        isMemberOrganization,
        //dwg cont
        isNew,
        isUpdatable,
        actions,
        fetchingActions,
        fetchActions,
        handleActions,
        onShowEmail,
        visibleEmail,
        onCancelEmail,
        emailTemplate,
        emailDetails,
        emailFiles,
        emailLines,
        isConfirmed,
        isIssued,
        modalID,
      }}
    />
  )
}

export default withRouter(AddDWGCont)
